"use client";

import { useSnapshot } from "valtio";
import { AccountState } from "../../stores/accountStore";
export function useConnectorId() {
  const {
    connectorId
  } = useSnapshot(AccountState);
  return connectorId;
}